const api = {
  url: '/api',
};

api.login = '/static/login.html';

export default api;
